// 根据contentType获取请求头config
export function getHeaderConfig(method, contentType, customHeaders) {
    const contentTypeMap = {
        json: 'application/json;charset=utf-8',
        form: 'application/x-www-form-urlencoded;charset=utf-8',
        file: 'multipart/form-data;charset=utf-8',
    };
    const headers = {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': contentTypeMap[contentType],
    };
    for (const key in customHeaders) {
        headers[key] = customHeaders[key];
    }
    return {
        [method]: headers,
    };
}

export function generateFormData(param) {
    const result = new FormData();
    for (const key in param) {
        if (Object.prototype.hasOwnProperty.call(param, key)) {
            result.append(key, param[key]);
        }
    }
    return result;
}

/**
 * 生成随机数
 * @param num 随机数位数
 */
export function createRamNum(num = 10) {
    let numStr = '';
    for (let i = 0; i < num; i++) {
        numStr += Math.floor(Math.random() * 10);
    }
    return numStr;
}